import { compareDesc } from "date-fns";
import { createSelector } from "reselect";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { notTaggedFilter } from "constants/filters";
import { Right } from "constants/right";
import Role from "constants/role";
import { alphabeticalSortBySelector } from "helpers/sort";
import { ALL_TEAMS_ID, selectCurrentAgentAssignedTeams } from "store/entities/teams";
import { IWithSessionState, hasRight } from "store/features/session";
import { getSelectedTeamId } from "store/views/settings";

import { IWithAgentsState, selectLoggedInAgentPermission } from "../agents";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { ITag } from "./interfaces";

interface IWithTagsState {
  entities: {
    tags: IEntityCollectionState<ITag>;
  };
}

export function selectTags(state: IWithTagsState): Record<string, ITag> {
  return state.entities.tags;
}

function sortByDates(a: ITag, b: ITag): number {
  const dateA = a.updatedAt || a.createdAt;
  const dateB = b.updatedAt || b.createdAt;
  return compareDesc(dateA, dateB);
}

export const selectTagsAlphabetically = createSelector(selectTags, (tags: Record<string, ITag>) =>
  Object.values(tags).sort(alphabeticalSortBySelector(tag => tag.name))
);

export const selectTagsByDates = createSelector(selectTags, (tags: Record<string, ITag>) =>
  Object.values(tags).sort(sortByDates)
);

export const selectAgentTagsAlphabetically = createSelector(
  [selectTagsAlphabetically, selectCurrentAgentAssignedTeams],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (tags: any, currentAgentTeams: any) => {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentAgentTeamIds: string[] = currentAgentTeams.map((team: any) => team.id);
    return tags.filter((tag: ITag) => tag.teamId === null || currentAgentTeamIds.includes(tag.teamId));
  }
);

export const selectSettingsTags = createSelector(
  [selectTagsByDates, getSelectedTeamId],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (tags: any, selectedTeamId: any) => {
    const teamId = selectedTeamId === ALL_TEAMS_ID ? null : selectedTeamId;
    return tags.filter((tag: ITag) => tag.teamId === teamId);
  }
);

/**
 * - for admins, returns all tags
 * - for agents, returns tags from teams agent is assigned to
 */
export const selectReportsTags = createSelector(
  [selectTagsAlphabetically, selectCurrentAgentAssignedTeams, selectLoggedInAgentPermission],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (tags: any, currentAgentTeams: any, loggedInAgentPermission: any) => {
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentAgentTeamIds: string[] = currentAgentTeams.map((team: any) => team.id);
    const isAdmin = loggedInAgentPermission === Role.Owner;

    const filteredTags = tags.filter(
      (tag: ITag) => isAdmin || tag.teamId === null || currentAgentTeamIds.includes(tag.teamId)
    );
    return [notTaggedFilter].concat(filteredTags);
  }
);

function canManageSharedTags(state: IWithSessionState & IWithAgentsState): boolean {
  return hasRight(state, Right.ManageSharedTags);
}

export const selectCanManageTags = createSelector(
  [getSelectedTeamId, canManageSharedTags],
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (selectedTeamId: any, manageSharedTags: any) => selectedTeamId !== ALL_TEAMS_ID || manageSharedTags
);
